<template>
    <div class="app-container">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/zltszhfw/rzfw' }">认证认可</el-breadcrumb-item>
                    <el-breadcrumb-item>三同企业发布详情</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>

        <el-row class="content">
            <h1  style="font-family: 微软雅黑, 宋体">{{detail.entname}}</h1>
            <el-row class="soure">
                <el-col :span="6">
                    <span style="padding-right: 15px;">发布时间：{{detail.fbTime}}</span>
                </el-col>
                <el-col :span="6">
                    <span style="padding-right: 15px;">访问量：{{browseCount}}</span>
                </el-col>
                <el-col :span="6">
                    <span>来源：{{fbDept}}</span>
                </el-col>
                <el-col :span="6">
                    <span>企业网址：{{detail.entweb}}</span>
                </el-col>
            </el-row>
            <div v-html="detail.qycy" class="eidt-content"></div>
            <!--            <div style="align-content: center" align="center"><img src="../../../../assets/images/file_tmp/taishan_tzgg.png" style="width: 1000px"></img></div>-->
        </el-row>

    </div>
</template>

<script>
    import {getBrowseCount} from "@/api/basedata/records";
    import {getStqyfb} from "@/api/zlts/rzfw/stqyfb";
    export default {
        name: "stqyFbDetail",
        data() {
            return {
                // 遮罩层
                loading: true,
                recid: undefined,
                type: undefined,
                detail: {},
                browseCount: undefined,
                fbDept: '威海市市场监督管理局',
                ywViews:{
                    busRecid:undefined,
                    busTableName:'yw_zlts_rzfw_tspztzgg',
                },
            }
        },
        created() {
            this.recid = this.$route.query.recid;
            this.getDetail();
        },
        methods: {
            toPage(url) {
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh() {
                this.getDetail();
            },
            getDetail() {
                const recid = this.recid || this.ids
                getStqyfb(recid).then(response => {
                    this.detail = response.data;
                });
                this.getBrowseData();
            },
            getBrowseData() {
                this.ywViews.busRecid= this.recid;
                getBrowseCount(this.ywViews).then(response => {
                    this.browseCount = response;
                })
            }
        }
    }
</script>

<style scoped>
    .app-container {
        padding: 0px 15px 20px;
        background-color: #ffffff;
    }

    .navigation {
        padding: 20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }

    .content {
        border: 1px solid #cccccc;
        padding: 20px 80px;
    }

    .soure {
        background-color: #f3f3f3;
        padding: 10px;
        margin: 25px 0;
    }
</style>